import { ColumnDef } from '@tanstack/react-table';
import React from 'react';
import { IDisburseAllDisbursementData } from 'types/order/escrow/IDisburseAllDisbursementData';
import { eDisbursementType } from 'types/order/escrow/eDisbursementType';
import { DisbursementTable } from './DisbursementTable';
import { Totals } from './Totals';
import { IDisbursementDictionary } from './IDisbursementDictionary';

export interface IAllDisbursementTables {
  selectedId?: string;
  columns: Record<eDisbursementType, ColumnDef<IDisburseAllDisbursementData, any>[]>;
  data: IDisbursementDictionary;
  setSelectedDisbursement?: (x: IDisburseAllDisbursementData) => void;
}

export const AllDisbursementTables: React.FC<IAllDisbursementTables> = ({
  columns,
  data,
  selectedId,
  setSelectedDisbursement,
}) => {
  const types = [
    eDisbursementType.ACH,
    eDisbursementType.Check,
    eDisbursementType.InternalTransfer,
    eDisbursementType.Wire,
  ];

  return (
    <>
      {types.map((t) => (
        <React.Fragment key={t}>
          <DisbursementTable
            header={t}
            data={data[t]}
            columns={columns[t]}
            selectedId={selectedId}
            setSelectedDisbursement={setSelectedDisbursement}
          />
          <Totals disbursements={(data[t] as IDisburseAllDisbursementData[]).filter((item) => item.enabled)} />
        </React.Fragment>
      ))}
    </>
  );
};
